import { getTestIds } from '../../utils/TestIds';
export const importLottiePlayerInner = ()=>import('./LottiePlayerInner').then((module)=>({
            default: module.LottiePlayerInner
        }));
export const GetLottiePlayerTID = (parentTestId)=>getTestIds(parentTestId);
